import { InputNumber, InputNumberProps } from "antd";
import { CURRENCY_LABEL } from "~/utils/finance/money";

interface CustomInputNumberProps extends InputNumberProps<number> {
  nonNegative?: boolean;
  whole?: boolean;
  /** Money input: 2 decimal places, FCFA suffix. */
  money?: boolean;
}

const wholeParser = (value?: string) => {
  if (value?.includes(".")) return Math.round(value as unknown as number);
  return value as unknown as number;
};

export const CustomInputNumber = ({
  nonNegative,
  whole,
  money,
  ...props
}: CustomInputNumberProps) => {
  if (money) {
    return (
      <InputNumber
        min={nonNegative === false ? props.min : 0}
        precision={2}
        step={0.01}
        suffix={CURRENCY_LABEL}
        {...props}
      />
    );
  }

  return (
    <InputNumber
      parser={whole ? wholeParser : undefined}
      min={nonNegative ? 0 : undefined}
      {...props}
    />
  );
};
